export default __webpack_public_path__ + "static/media/944-2.82b182bd.svg";